export default __webpack_public_path__ + "static/media/image-8.9d6fdd02.jpg";